export default "__VITE_ASSET__rmo_P5pO__"